import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { HttpService } from '../../../http.service';

import { Router } from  '@angular/router';
declare var $: any;

import { SocialAuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registrationForm: FormGroup;
  isSubmitted  =  false;
  registrationMessage : String='';
  registrationSpin:Number=0;
  registerSpinGoogle:Number=0;
   ROOT_BASEURL = environment.ROOT_BASEURL;
		
  constructor(
	private authServicesocial: SocialAuthService,
	private _http: HttpService,
	private formBuilder: FormBuilder,
	public router: Router

  ) { }

  ngOnInit(): void {
	  	$('.invalid-number').hide();
	   this.registrationForm  =  this.formBuilder.group({
            email: ['', [Validators.required]],
			phone_no: ['', Validators.required, Validators.maxLength(10)],
			fullname: ['', Validators.required],
			password: ['', Validators.required],
			confirmPassword: ['', Validators.required]
		}
		);
	
		this.authServicesocial.authState.subscribe((user : any) => {
				this.registerSpinGoogle=1;
				this.registerWithSocialMedia(user);

		});	
		
		setTimeout(function() {
			$('.modal-backdrop').remove();
			$('body').removeClass('cart-open');
			$('html').css('overflow','auto');
		}, 500);
	
  }
	
	removeAttribute (className) {
		$("."+className).removeAttr("readonly");
	}
	termConditionIframe () {
		var url = window.location.origin+'/admin/term_conditions.html';
		$('#termandconditions-iframe').attr('src', url);
		$('#termandconditions').modal('show');
	}
	signupWithGoogle(): void {
		this.authServicesocial.signIn(GoogleLoginProvider.PROVIDER_ID);
	}
  get formControls() { return this.registrationForm.controls; }
	
	//register With Socical Media
	registerWithSocialMedia (socailMediaUser) {
		var loginQueryParms="";
		
		if(socailMediaUser.provider==='GOOGLE'){
			loginQueryParms+="email="+socailMediaUser.email;
			loginQueryParms+="&fullname="+socailMediaUser.name;
			loginQueryParms+="&res_id=49";
			loginQueryParms+="&login_type=Google";
			loginQueryParms+="&referral_code=Google";
			loginQueryParms+="&os=website";
			loginQueryParms+="&phone_no=";

		}
		this._http.getRequest('userlogin.php?'+loginQueryParms,'').subscribe(data => {
			this.registerSpinGoogle=0;
			if (data[0].status==='Success') {
				localStorage.setItem('isLogin' ,'1');
				localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
				localStorage.setItem('user_detail' ,JSON.stringify(data[0].user_detail));
				this.router.navigateByUrl('/locations'); 
			} else {
				alert("Invalid details.");
			}
		});
		
	}
	
	
	registration(){
	$('.invalid-number').hide();
	if($('#agree-term-condition').prop("checked") == true){
	} else {
		this.registrationMessage = "Please accept the terms and conditions first."
		return ;
	}
	if (!this.registrationForm.value.email.includes('@')) {
		this.registrationMessage = "Invalid email address";
		return ;
	}
	this.registrationMessage = "";
	this.isSubmitted = true;
	if(this.registrationForm.invalid){
	  return;
	}
	var is_number_valid = this.isAmericanNumber(this.registrationForm.value.phone_no);
	if (is_number_valid==false) {
		$('.invalid-number').show();
		return ;
	} 
	if (this.registrationForm.value.password!=this.registrationForm.value.confirmPassword) {
		this.registrationMessage ="Password is not matched with confirm password";
		return;
	}
	
	this.registrationSpin = 1;
	const registration = new FormData();
	registration.append('email', this.registrationForm.value.email);
	registration.append('password', this.registrationForm.value.password);
	registration.append('phone_no', this.registrationForm.value.phone_no);
	registration.append('fullname', this.registrationForm.value.fullname);
	registration.append('res_id', '49');
	registration.append('referral_code', 'q2e');
	registration.append('os', 'website');

	this._http.postRequest('userregister.php',registration).subscribe((reponse : any )=>{
		if(reponse[0].status==='Failed'){
			this.registrationMessage = reponse[0].error;

		} else if(reponse[0].status==='Success'){
			this.registrationMessage = "Your account has been created.";
		}
		this.registrationSpin = 0;

	}); 

	}
	isAmericanNumber(str) {
	    var isphone = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(str);
		return isphone;	
	}
}
